// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="'Edit loan metadata'"></sub-header>

  <div class="alert alert--danger" ng-if="!\$ctrl.selectedPerformanceValid()">
    <span>
      Manual setting of performance to Written Off is not allowed. Please use write off feature to write off a loan.
    </span>
  </div>

    <ng-form name="\$ctrl.form">
      <validator condition="\$ctrl.selectedPerformanceValid()" ></validator>
      <table class="table">
        <tbody>
        <tr>
          <td class="label">Mode:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.metadata.manualMetadata"
                    ng-options="o.value as o.label for o in [{ label: 'Automatic', value: false }, { label: 'Manual', value: true }]">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">PastDueClassification:</td>
          <td class="values">
            <select ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata"
                    ng-model="\$ctrl.clonedLoan.metadata.pastDueClassification"
                    ng-options="entry.code as entry.label for entry in \$ctrl.pastDueClassificationCodes">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Performance:</td>
          <td class="values">
            <select ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata || !\$ctrl.clonedLoan.metadata.performance === 'WRITTEN_OFF'"
                    ng-model="\$ctrl.clonedLoan.metadata.performance"
                    ng-options="entry.code as entry.label for entry in \$ctrl.performanceCodes">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Litigation:</td>
          <td class="values">
            <select ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata"
                    ng-model="\$ctrl.clonedLoan.metadata.litigation" boolean-options>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Restructured:</td>
          <td class="values">
            <select ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata"
                    ng-model="\$ctrl.clonedLoan.metadata.restructured" boolean-options="">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Impaired:</td>
          <td class="values">
            <select ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata"
                    ng-model="\$ctrl.clonedLoan.metadata.impaired" boolean-options="">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">ProvisionRate:</td>
          <td class="values">
            <glue-container append-percentage="true">
              <input ng-disabled="!\$ctrl.clonedLoan.metadata.manualMetadata"
                     type="number"
                     ng-model="\$ctrl.clonedLoan.metadata.provisionRate"
                     ng-required="true"
                     min="0" max="10000" step="0.01">
            </glue-container>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-primary"
                ng-click="\$ctrl.save()"
                type="button"
                ng-disabled="\$ctrl.form.\$invalid">
          Save
        </button>
      </div>
    </ng-form>
</section>


`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-metadata.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;